import { FieldType } from "@shared/features/form/Form";
import { FormDialog } from "@shared/features/form/FormDialog";
import { useDialog } from "@shared/features/dialog/useDialog";
import { codeSchema } from "../../orgInvitation.schemas";
import { codeFields } from "../../orgInvitation.fields";
import { useSubmitCode } from "../../hooks/useSubmitCode";

export function OrgCodeDialog() {
  const { openDialog } = useDialog();

  const submitCode = useSubmitCode();

  return (
    <FormDialog
      dialogName="code"
      title="Join Pollinator"
      description="The inaugural Pollinator Program launches in October of 2025. Join a peer circle for five weeks of focused creative momentum."
      successTitle={`Code Found`}
      successDescription={`Redirecting...`}
      schema={codeSchema}
      fields={codeFields as FieldType[]}
      onSubmit={submitCode.mutateAsync}
      onSecondaryClick={() => openDialog("orgLookup")}
      primaryButtonText="Join"
      secondaryButtonText="I don't have a code"
    />
  );
}

export default OrgCodeDialog;
